export function now () {
  return Math.floor(Date.now() / 1000);
}